import { render } from "./Sort.vue?vue&type=template&id=4f8307b4&scoped=true&ts=true"
import script from "./Sort.ts?vue&type=script&lang=ts&external"
export * from "./Sort.ts?vue&type=script&lang=ts&external"

import "./Sort.scss?vue&type=style&index=0&id=4f8307b4&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8307b4"]])

export default __exports__